/**
 * GZOO AI Marketing - Theme Provider
 * Using next-themes for SSR-safe theme switching
 */

'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem={true}
      storageKey="theme"
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}

// Export useTheme from next-themes for compatibility
export { useTheme } from 'next-themes';
